import React from "react";
import "./chatbotsettings.scss";
import Chatbot from "../../../components/chatbot";
import Chatbotdetails from "./chatbotdetails";
import { useSelector, useDispatch } from "react-redux";
// import toast from "react-hot-toast"; // Unused
import { setSelectedProject } from "../../../store/slices/projectSlice";
// import Embeddingscript from "../embeddingscript"; // Unused

export default function Chatbotsettings() {
  // const { embeddingFile } = useSelector((state) => state.embedding); // Unused
  const { selectedProject } = useSelector((state) => state.project);
  const dispatch = useDispatch();

  // Tab state: 'general', 'knowledge', 'integration'
  const [activeTab, setActiveTab] = React.useState('general');

  // Sync internal state with external simple "isKnowledgeChat" boolean
  // If Integration is selected, we don't necessarily change strict mode, visuals handled locally
  const isKnowledgeChat = selectedProject?.is_knowledge_chat || false;

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === 'knowledge') {
      // Previously blocked if embeddingFile.length <= 0. 
      // Removed to allow selecting from Global Knowledge Base via KBSelection.
      dispatch(setSelectedProject({ ...selectedProject, is_knowledge_chat: true }));
    } else if (tab === 'general') {
      dispatch(setSelectedProject({ ...selectedProject, is_knowledge_chat: false }));
    }
    // 'integration' tab doesn't change bot mode
  };

  // Sync initial state
  React.useEffect(() => {
    if (isKnowledgeChat) {
      if (activeTab === 'general') setActiveTab('knowledge');
    } else {
      if (activeTab === 'knowledge') setActiveTab('general');
    }
  }, [isKnowledgeChat, activeTab]);

  return (
    <div>
      <div className="chatbot-setting-all-content-alignment">
        <div className="flex-box">
          <div className="flex-box-items">
            <Chatbotdetails isKnowledgeChat={activeTab === 'knowledge'} />
          </div>
          <div className="flex-box-items">
            <div className="tab-design-new">
              <button
                className={activeTab === 'general' ? "active" : ""}
                onClick={() => handleTabChange('general')}
              >
                General Chat
              </button>
              <button
                className={activeTab === 'knowledge' ? "active" : ""}
                onClick={() => handleTabChange('knowledge')}
              >
                Knowledge Chat
              </button>
            </div>
            <Chatbot isKnowledgeChat={isKnowledgeChat} />
          </div>
        </div>
      </div>
    </div>
  );
}
